import { Component, ViewChild } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-resident-base-trip-list',
	templateUrl: './resident-base-trip-list.component.html',
	styleUrls: ['./resident-base-trip-list.component.css'],
})
export class ResidentBaseTripListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 1;
	protected apiUrl = 'resident/residentBaseTrips';
	filters;
	parameters = {
		destinations: [],
	};
	tableRows = [
		{ id: 'destinations', name: 'Destynacja' },
		{ id: 'name', name: 'Nazwa' },
	];

	protected loadBefore() {
		this.api.get('/bag/bagLocations/', (result, error) => {
			this.parameters.destinations = result.data.filter((obj) => ['11', '12', '143', '144'].includes(obj.id));
		});
	}

	protected convertData(data) {
		data.forEach((obj) => {
			obj.destinations = obj.destinations.map((item) => item.name);
		});
		return data;
	}
}
